import { useState, useMemo, useEffect } from 'react';
import { Modal, Select } from 'antd';
import { CARD_TYPES } from '../cardTypes';

const ALL_CARD_TYPE_OPTIONS = [
	{ value: CARD_TYPES.CALL_TO_ACTION, label: 'Call to Action' },
	{
		value: CARD_TYPES.CALL_TO_ACTION_REFERRAL,
		label: 'Call to Action - Referral',
	},
	{
		value: CARD_TYPES.CALL_TO_ACTION_GENERAL,
		label: 'Call to Action - General',
	},
	{ value: CARD_TYPES.CALL_TO_ACTION_LEAD, label: 'Call to Action - Lead' },
	{
		value: CARD_TYPES.CALL_TO_ACTION_INTERNAL,
		label: 'Call to Action - Internal',
	},
	{
		value: CARD_TYPES.CALL_TO_ACTION_RECOGNITION,
		label: 'Call to Action - Recognition',
	},
	{ value: CARD_TYPES.JOB_ALERTS, label: 'Job Alerts' },
	{ value: CARD_TYPES.OPEN_JOBS, label: 'Open Jobs' },
	{ value: CARD_TYPES.LEADERBOARD, label: 'Leaderboard' },
	{ value: CARD_TYPES.YOUR_REFERRALS, label: 'Your Referrals' },
	{ value: CARD_TYPES.POINTS_RANKING, label: 'Points Ranking' },
	{ value: CARD_TYPES.REFERRALS_RANKING, label: 'Referrals Ranking' },
	{ value: CARD_TYPES.ANNOUNCEMENTS, label: 'Announcements' },
	{ value: CARD_TYPES.RECENT_JOBS, label: 'Recent Jobs' },
	{ value: CARD_TYPES.ANNOUNCEMENT_THUMBNAIL, label: 'Announcement Thumbnail' },
	{ value: CARD_TYPES.RECOGNITION_SHOUTOUTS, label: 'Recognition Shoutouts' },
	{ value: CARD_TYPES.MY_RECOGNITIONS, label: 'My Recognitions' },
	{ value: CARD_TYPES.RECOGNITION_LEADERBOARD, label: 'Recognition Leaderboard' },
	{ value: CARD_TYPES.CUSTOM_HTML, label: 'Custom HTML' },
];

const MULTI_INSTANCE_TYPES = [
	CARD_TYPES.CALL_TO_ACTION,
	CARD_TYPES.CUSTOM_HTML,
	CARD_TYPES.ANNOUNCEMENT_THUMBNAIL,
];

export function CardTypeSelectorModal({
	isOpen,
	onClose,
	onSelectCardType,
	existingCards = [],
}) {
	const existingCardTypes = useMemo(
		() => new Set(existingCards.map((card) => card.type)),
		[existingCards]
	);

	const availableOptions = useMemo(
		() =>
			ALL_CARD_TYPE_OPTIONS.filter(
				(option) =>
					MULTI_INSTANCE_TYPES.includes(option.value) ||
					!existingCardTypes.has(option.value)
			),
		[existingCardTypes]
	);

	const defaultType = availableOptions[0]?.value || CARD_TYPES.CALL_TO_ACTION;
	const [selectedType, setSelectedType] = useState(defaultType);

	useEffect(() => {
		if (isOpen) {
			setSelectedType(availableOptions[0]?.value || CARD_TYPES.CALL_TO_ACTION);
		}
	}, [isOpen, availableOptions]);

	const handleOk = () => {
		onSelectCardType(selectedType);
		onClose();
	};

	const handleCancel = () => {
		onClose();
	};

	return (
		<Modal
			title="Select Card Type"
			open={isOpen}
			onOk={handleOk}
			onCancel={handleCancel}
			okText="Add Card"
			cancelText="Cancel"
		>
			<div className="space-y-2">
				<label className="block text-sm font-medium text-gray-700 mb-2">
					Choose a card type to add:
				</label>
				<Select
					value={selectedType}
					onChange={setSelectedType}
					options={availableOptions}
					className="w-full"
					size="large"
				/>
			</div>
		</Modal>
	);
}
